var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account",staticStyle:{"background":"#fff"}},[_c('accountForm',{attrs:{"isEdit":_vm.isEdit,"accountName":_vm.accountName},on:{"accountWay":_vm.editAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }